import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";

import {setDiscountSections} from "./discountsActions";
import {
  DISCOUNT_SECTION_TYPES,
  discountInterFace,
  discountSectionsInterface,
  DISCOUNT_FINANCE_CELLS
} from "./discountsInterface";
import Select5 from "../Generic/Select5";
import {getParsedWizardLogic, getUpdatedSections} from "./discountsFunctions";


const DiscountFinanceCells = (props) => {
  const {discount, discountSection, discountSections, setDiscountSections, workSheetsActiveIndex} = props;

  const financeSection = discountSections.find(section => {
    if (section.type !== DISCOUNT_SECTION_TYPES.finance) {
      return
    }
    const wizLogic = getParsedWizardLogic(section, workSheetsActiveIndex);
    return wizLogic.index === workSheetsActiveIndex
  });
  const dropDownItems = financeSection && financeSection.discounts.length
    ? financeSection.discounts.map((discount) => {
      return {
        value: discount.uuId,
        label: discount.financePercentage + "%" + " for " + discount.financeMonths + " Months",
        html: (
          <span className="select3-dropdown__list-item-text flex flex--between width-95 line--16">
            <span>{discount.financePercentage + "%" + " for " + discount.financeMonths + " Months"}</span>
            <span>{discount.financeSalesPercentage + "%"}</span>
          </span>
        )
      }
    }) : [];

  let parsedOptions = typeof discount.financeOptions === "string"
    ? JSON.parse(discount.financeOptions)
    : [];

  return (
    <div className="flex-item flex flex--center flex--between margin-r8 height-100 relative">
      <span className="discount-finance__top text-none">Set default months with desired percentage.</span>
      {Object.keys(DISCOUNT_FINANCE_CELLS).map((property, propertyIndex) => {

        const selectedItem = dropDownItems.find(item => item.value === parsedOptions[propertyIndex]);

        const onItemClick = (selectItem) => {
          parsedOptions[propertyIndex] = selectItem.value;
          let newSections = getUpdatedSections(discountSections,
            discountSection,
            discount,
            "financeOptions",
            JSON.stringify(parsedOptions)
          )
          setDiscountSections(newSections);
        }

        return (
          <div className="discount-cell discount-cell--finance-select discount-cell--ridged1 padding-r16 padding-l16 height-100 text-none"
               key={property}>
            <Select5 selectItems={dropDownItems}
                     selectItemClick={onItemClick}
                     selectedItem={selectedItem}
                     useGraySelect={true}
              // placeholder={intl.formatMessage({id: "features.setup.markUpDownPopup.checkbox.currency"})}
                     placeholder={"Set Default Months"}
                     className={"select--gray"}
                     maxItems={6} />
          </div>
        )
      })}
    </div>
  )
}

DiscountFinanceCells.propTypes = {
  discount: PropTypes.shape(discountInterFace),
  discountSection: PropTypes.shape(discountSectionsInterface),
}

const mapStateToProps = (store) => {
  const {workSheetsActiveIndex, discountSections} = store.discountsState;

  return {
    workSheetsActiveIndex,
    discountSections
  };
};

const mapDispatchToProps = {
  setDiscountSections
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountFinanceCells);
